import { action, observable } from 'mobx';
import { CustomPageEntity } from './custom-page.entity';
import { CustomPageEntityCollection, PageID } from './index';


export class CustomPagesCollection implements CustomPageEntityCollection {
    @action.bound
    public reset(): void {
        this.collection.clear();
    }

    @action.bound
    public add(entity: CustomPageEntity): void {
        this.collection.set(entity.getId(), entity);
    }
    @action.bound
    public update(entity): void {
        if (this.collection.has(entity.getId())) this.collection.set(entity.getId(), entity);
    }
    @action.bound
    public removeById(id: string | number): void {
        this.collection.delete(id);
    }

    public get(): CustomPageEntity[] {
        return this.values;
    }

    public getById(id: string | number): CustomPageEntity {
        return this.collection.get(id);
    }

    public getByPagePath(path: string): CustomPageEntity {
        return this.values.find(v => v.isPagePathEqual(path));
    }

    public isEmpty(): boolean {
        return this.collection.size === 0;
    }

    private get values(): CustomPageEntity[] {
        return [...this.collection.values()];
    }

    @observable
    private readonly collection: Map<PageID, CustomPageEntity> = new Map();
}
